import { gql } from '@apollo/client';
const REMOVE_PRODUCT_SUSTAINABILITY = gql `
  mutation RemoveProductSustainability($productSustainabilityId: ID!) {
    removeProductSustainability(productSustainabilityId: $productSustainabilityId) {
      removed
    }
  }
`;
export default REMOVE_PRODUCT_SUSTAINABILITY;
